import QWLogo from 'assets/images/poweredBy_logo.png'
import config from 'config';

import { FC } from 'react';
// Redux
import { useAppSelector } from 'hooks/useStore';
import { selectResult } from 'store/player/playerSelectors';
import { selectQuiz } from 'store/quiz/quizSelectors';
import IQuiz from 'models/Quiz';
//
import { QRCodeCanvas } from "qrcode.react";

import classes from './styles.module.css';

type Props = {
  isLargeScreen: boolean;
}

const QrCode:FC<Props> = ({ isLargeScreen }) => {
  const result:any = useAppSelector(selectResult);
  const storeQuiz = useAppSelector(selectQuiz);
  const quiz:IQuiz | null = storeQuiz || result?.quiz || null;

  const qrCodeLink = quiz?.publicLeaderboard.quizQRCodeLink || `${config.quizURL}/quiz/${quiz?.quizNameSlug}`;
  const logoImage = result ? result.quizGroup ? result.quizGroup.logoImage : result.quiz.logoImage : '';

  return (
    <div className="w-full order-1 xl:order-none flex justify-between gap-8">
      <div className="" style={{
          width: isLargeScreen ? quiz?.publicLeaderboard.quizQRCodeTitle ? '280px' : '328px' : '140px',
          height: isLargeScreen ? '328px' : 'auto',
        }}
      >
        {quiz && quiz.publicLeaderboard.quizQRCodeEnabled && (
          <div className={`${classes.qrWrapper} flex flex-col p-2 bg-white rounded-xl w-full h-full`}>
            <h2 className="text-xs font-bold text-black text-center text-wrap sm:text-xl">{quiz?.publicLeaderboard.quizQRCodeTitle}</h2>
            <QRCodeCanvas
              value={qrCodeLink}
              level="H"
              size={isLargeScreen ? quiz?.publicLeaderboard.quizQRCodeTitle ? 264 : 302 : 124}
              imageSettings={{
                src: quiz.publicLeaderboard.quizQRCodeLogo || QWLogo,
                width: isLargeScreen ? 120 : 60,
                height: isLargeScreen ? 47 : 23,
                excavate: true
              }}
            />
          </div>
        )}
      </div>
      <div
        className="flex-grow rounded-xl object-cover"
        style={{
          height: isLargeScreen ? '328px' : 'auto',
          backgroundImage: `url(${logoImage})`,
          backgroundSize: 'contain',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      />
    </div>
  )
}

export default QrCode;